export default "__VITE_ASSET__B3GAIRX9__"